export const ALERTS_DOMAIN = "alerts/";

export const SET_WARNING_MESSAGE = ALERTS_DOMAIN + "setWarning";
export const CLEAR_WARNING_MESSAGE = ALERTS_DOMAIN + "clearWarning";

export const SET_ERRORS = ALERTS_DOMAIN + "setErrors";
export const CLEAR_ERRORS = ALERTS_DOMAIN + "clearErrors";

export const SET_INFO_MESSAGE = ALERTS_DOMAIN + "setInfo";
export const CLEAR_INFO_MESSAGE = ALERTS_DOMAIN + "clearInfo";

export const SET_SUCCESS_MESSAGE = ALERTS_DOMAIN + "setSuccess";
export const CLEAR_SUCCESS_MESSAGE = ALERTS_DOMAIN + "clearSuccess";
